import React from 'react';

import Button from 'components/shared/Button';

import { CustomFontsContextProvider } from './context';
import FontsForm from './FontsForm';
import s from './index.module.css';
import Table from './Table';
import useCustomFonts from './useCustomFonts';

function CustomFonts(props) {
  const context = useCustomFonts(props);
  const { handleSave, openFontsForm, handleOpenFontsForm } = context;

  return (
    <CustomFontsContextProvider data={context}>
      <div className={s.wrapper}>
        <Table />

        {openFontsForm && <FontsForm />}
        {!openFontsForm && (
          <div className={s.actions}>
            <Button type="default" onClick={handleOpenFontsForm}>
              Upload Fonts
            </Button>

            <Button onClick={handleSave}>Save Fonts</Button>
          </div>
        )}
      </div>
    </CustomFontsContextProvider>
  );
}

export default CustomFonts;
